import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Organization = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 14 12"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M0 11.5H2M14 11.5H12M2 11.5V0.5H12V11.5M2 11.5H12M4 3H6M8 3H10M4 6H6M8 6H10M4 9H6M8 9H10" />
    </svg>
  ),
)
Organization.displayName = 'Organization'

export default Organization
